import security from "@/main";
import Core from "@/modules/core/service/Core";
import { getApiBaseUrl } from "@/config";

const url = {
    all      : "/api/company/index",
    filter   : "/api/company/search",
    company  : "/api/company/{0}",
    branches : "/api/company/{0}/branch",
    contacts : "/api/company/{0}/contact",
    customer : "/api/company/{0}/customer"
};


/**
 * Retrieves a list of companies according to the given filter criteria.
 *
 * @param url       the URL used for the request.
 * @param customer  find all companies that have a contract with in the context of the customer
 * @param roles     find all companies with one of the given roles
 * @param parent    find all companies assigned to the given parent
 * @param hierachie organizes the result as a hierarchy of companies
 * @param success   callback handler
 */
const companies = function (url, customer, parent, roles, hierachie, success) {
    fetch(getApiBaseUrl() + url, {
        method: "POST",
        headers: security.jsonHeader(),
        body: JSON.stringify({
            roles    : roles,
            hierachie: hierachie,
            customer : customer,
            parent   : parent
        })
    })
        .then(blob => blob.json())
        .then(data => {
            success(data);
        })
};

export default {
    roles: {
        customer          : 1,
        facilitymanagement: 2,
        maintenance       : 3,
        escalation        : 4,
        inspection        : 5,
        customercompany   : 8,
        facilityAdmin     : 10,
        execution         : 11,
        onlyComponents    : 12,
        manufacturer      : 13,
    },

    status: {
        active   : 1,
        renaming : 2,
        inactive : 3
    },

    unknown: 1,

    index (customer, roles, hierachie, success) {
        companies(url.all, customer, null, roles, hierachie, success);
    },

    get (companyId) {
        return Core.method.get (url.company, companyId);
    },

    companiesByRoles(roles) {
        return Core.method.post(url.filter, {
            roles: roles
        });
    },

    customersByCompany (company, success) {
        return fetch(getApiBaseUrl() + url.customer.replace("{0}", company), {
            method: "GET",
            headers: security.jsonHeader(),
        })
            .then(blob => blob.json())
            .then(data => {
                success(data);
            })
    },

    branches(parent, success) {
        return fetch(getApiBaseUrl() + url.all, {
            method: "POST",
            headers: security.jsonHeader(),
            body: JSON.stringify({
                parent: parent,
                roles: []
            })
        })
            .then(blob => blob.json())
            .then(data => {
                success(data);
            })
    },

    contacts(company, filter, success) {
        return fetch(getApiBaseUrl() + url.contacts.replace("{0}", company), {
            method: "POST",
            headers: security.jsonHeader(),
            body: JSON.stringify(filter)
        })
            .then(blob => blob.json())
            .then(data => {
                success(data);
            })
    },

    store (component, company, success, error) {
        if (!company.id) {
            Core.method.post(url.company.replace("/{0}", ""), company).then ((data) => {
                Core.message.alert.save(component);
                if (success) success(data);
            }).catch((info) => {
                error (info);
            })
        } else {
            Core.method.put(url.company, company, company.id).then((data) => {
                Core.message.alert.save(component);
                if (success) success(data);
            }).catch((info) => {
                error (info);
            })
        }
    },

    filter (company, filter) {
        if (!filter) {
            return true;
        }

        if (company.name && company.name.includes (filter)) {
            return true;
        }

        if (company.nameAdd && company.nameAdd.includes(filter)) {
            return true;
        }

        if (company.street && company.street.includes (filter)) {
            return true;
        }

        if (company.city && company.city.includes (filter)) {
            return true;
        }

        if (company.zip && company.zip.includes (filter)) {
            return true;
        }

        return false;
    }
}